import { TestGraph } from "../../../types";
import Graph from "../Graph";
import enlargeIcon from "../../../assets/icons/enlarge-icon.svg";
import { useGraphEnlarge } from "../../../context/GraphEnlargeContext";

const GraphItem = ({
    graphData,
    isPartialMode,
    disabled = false,
    isLeftGraph = false,
}: {
    graphData: TestGraph;
    isPartialMode: boolean;
    disabled?: boolean;
    isLeftGraph?: boolean;
}) => {
    const { setGraphIdToEnlarge } = useGraphEnlarge();
    return (
        <div className={`flex flex-col gap-[5px]`}>
            <div className="flex items-center justify-between">
                <h6 className="text-black text-sm xl:text-base font-bold">
                    {graphData.title}
                </h6>
                <button
                    className={`${
                        isPartialMode
                            ? "size-6 xl:size-[30px]"
                            : "size-5 xl:size-5"
                    }`}
                    onClick={() => setGraphIdToEnlarge(graphData.graph_id)}
                >
                    <img
                        src={enlargeIcon}
                        alt="Enlarge Icon"
                        className="w-full h-full"
                    />
                </button>
            </div>
            <Graph
                graphData={graphData}
                size={isPartialMode ? "md" : "sm"}
                disabled={disabled}
                isLeftGraph={isLeftGraph}
            />
        </div>
    );
};

export default GraphItem;
